<form class="user-form" id="form">
        <input type="text" id="search" (keydown.enter)="$event.preventDefault()" placeholder="Search a Chess.com User">
        <button type="button" id="btn"  class="btn btn-dark" (click)="searchUser()" [routerLink]="['/searchresult']">
            <i class="fas fa-search"></i>
        </button>
</form>

<app-user *ngIf="search" [search]= "search"></app-user>
<app-bullet *ngIf="search" [search]= "search"></app-bullet>
<app-blitz *ngIf="search" [search]= "search"></app-blitz>